import React from 'react';
import PropTypes from 'prop-types';

const ProductSearchResultsNonFound = ({text}) =>
<div>
    {text || "No Products Found"}
</div>;

ProductSearchResultsNonFound.propType = { text: PropTypes.string };

export default ProductSearchResultsNonFound;




// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/ProductSearchResultsNonFound.jsx